import {useContext} from 'react'
import {ClassificationContext} from '../../context'
import {Select} from '../../../../components/Select/'
import Date from '../../../../components/Date/Date'
import usePermission from '../../../../hook/usePermission'
import {parseClassificationTableRowData} from '../../utils'

const ClassificationTableRow = ({row: rowData, actionComponent, checkBoxComponent}: any) => {
  const {Classifications, onClassificationChange} = useContext(ClassificationContext)
  const {hasPermission} = usePermission()
  const isPermission = hasPermission('analytics_replenishment_dashboard', 'write')
  const row = parseClassificationTableRowData(rowData)

  return (
    <tr>
      {checkBoxComponent && <td>{checkBoxComponent(row)}</td>}
      <td>{row.sku}</td>
      <td>
        <div className='d-flex align-items-center py-2'>
          <div className='symbol symbol-40px me-3 border'>
            <img src={row.thumbnail_url} alt='productimage' />
          </div>
          <div className='d-flex flex-column'>
            <span>{row.product_title}</span>
          </div>
        </div>
      </td>
      <td>{row.old_classification}</td>
      <td>
        <Select
          id={'new_classification'}
          placeholder={'Select Classification'}
          options={Classifications}
          isNullable={true}
          placeholderValue={''}
          value={row.new_classification || ''}
          disabled={!isPermission}
          onChange={(e) =>
            onClassificationChange({request_ids: [row?.id], new_classification: e.target.value})
          }
        />
      </td>
      <td>{row.created_by}</td>
      <td>
        <Date date={row.created_at} />
      </td>
      {actionComponent && <td>{actionComponent(row)}</td>}
    </tr>
  )
}

export default ClassificationTableRow
